import { API } from "../api/api";

export default function LogoutButton() {
  const logout = async () => {
    try {
      await API.post("/auth/logout", null, { withCredentials: true });
    } catch (err) {
      console.error("Logout failed:", err);
    } finally {
      window.location.href = "/login";
    }
  };

  return (
    <button onClick={logout} style={{ marginTop: "20px" }}>
      Logout
    </button>
  );
}